import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Quote.module.scss";
export const Quote: React.FC<{
  quote: string;
  quotationMarks?: boolean;
  offset: "Left" | "Right" | "None";
}> = t0 => {
  const $ = _c(7);
  const {
    quote,
    quotationMarks,
    offset
  } = t0;
  let quoteClasses;
  if ($[0] !== offset) {
    quoteClasses = [styles.quote];
    if (offset === "Left") {
      quoteClasses.push(styles.offsetLeft);
    }
    if (offset === "Right") {
      quoteClasses.push(styles.offsetRight);
    }
    $[0] = offset;
    $[1] = quoteClasses;
  } else {
    quoteClasses = $[1];
  }
  const t1 = quoteClasses.join(" ");
  const t2 = quotationMarks && "\u201C";
  const t3 = quotationMarks && "\u201D";
  let t4;
  if ($[2] !== quote || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = <div className={styles.container}><h5 className={t1}>{t2}{quote}{t3}</h5></div>;
    $[2] = quote;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};